






































































import Vue from 'vue';
import ChangeEmployerRequestViewModel from '@/src/services/viewModel/resource/ChangeEmployerRequestViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    isSaving: false,
    isLoading: false,
    errorResponse: undefined as string | undefined,
    employerAddressWasChanged: false,
    changeEmployer: new ChangeEmployerRequestViewModel(),
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
  },
  async mounted() {
    this.isLoading = true;
    const membershipData = await this.$service.api.memberships.getMyMembership();
    this.changeEmployer.employerAddress = membershipData?.membership?.firstEmployer?.address!;
    this.isLoading = false;
  },
  methods: {
    async putEmployer() {
      if (!this.changeEmployer.validate()) {
        return;
      }
      this.isSaving = true;
      this.errorResponse = '';
      this.employerAddressWasChanged = false;
      try {
        const membershipData = await this.$service.api.memberships.getMyMembership();
        this.changeEmployer.oldData = membershipData?.membership?.firstEmployer?.address;
        await this.$service.api.memberships.putMyEmployerAddress(this.changeEmployer);
        this.employerAddressWasChanged = true;
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isSaving = false;
    },
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/member-data/member-data-change');
    },
  },
});
